import { Delete, Space, X } from 'lucide-react'

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.split('')
const DIGITS = ['1','2','3','4','5','6','7','8','9','','0','']

interface Props {
  onKey: (character: string) => void
  onBackspace: () => void
  onClear: () => void
  /** 'text' is the 6-column alphanumeric grid; 'digits' is a numeric keypad. */
  mode?: 'text' | 'digits'
  navKey?: string
  /** marks the first key as the screen's entry point for focus restoration */
  entrySection?: string
  upSection?: string
  autofocus?: boolean
}

/**
 * Typing with a D-pad needs a grid on screen, not the system IME covering it.
 * Shared by search and by the admin interface.
 */
export function GridKeyboard({ onKey, onBackspace, onClear, mode = 'text', navKey = 'keyboard', entrySection, upSection, autofocus = true }: Props) {
  const keys = mode === 'digits' ? DIGITS : LETTERS
  const columns = mode === 'digits' ? 3 : 6
  const first = keys.find((key) => key.trim())

  return (
    <div className="keyboard">
      <div
        className={`keyboard-grid${mode === 'digits' ? ' keypad' : ''}`}
        style={{ ['--keys' as string]: String(columns) }}
        data-nav-group="grid"
        data-nav-columns={columns}
        data-nav-key={navKey}
      >
        {keys.map((key, index) => (key ? (
          <button
            className="key"
            data-focusable
            // the cell this key occupies, so blanks do not shift the ones after it
            data-nav-index={index}
            data-autofocus={autofocus && key === first ? '' : undefined}
            data-screen-entry={entrySection && key === first ? entrySection : undefined}
            data-nav-up-section={upSection && index < columns ? upSection : undefined}
            key={key}
            onClick={() => onKey(key)}
          >{key}</button>
        ) : <span className="key key-blank" key={`blank-${index}`} aria-hidden="true" />))}
      </div>
      <div className="keyboard-row" data-nav-group="row" data-nav-key={`${navKey}-actions`}>
        {mode === 'text' ? (
          <button className="key wide" data-focusable aria-label="Space" onClick={() => onKey(' ')}><Space size="1.5rem" /></button>
        ) : null}
        <button className="key wide" data-focusable aria-label="Backspace" onClick={onBackspace}><Delete size="1.5rem" /></button>
        <button className="key wide" data-focusable aria-label="Clear" onClick={onClear}><X size="1.5rem" /></button>
      </div>
    </div>
  )
}
